import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import ProjectsView from '@/views/ProjectsView.vue'
import VideosView from '@/views/VideosView.vue'
import ContactView from '@/views/ContactView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/lab',
    name: 'Lab',
    component: ProjectsView
  },
  {
    path: '/videos',
    name: 'Videos',
    component: VideosView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    // Bankshot! (Game Boy) home: web build (public/bankshot/play), ROM download, link to the leaderboard
    path: '/bankshot',
    name: 'Bankshot',
    component: () => import('@/views/BankshotView.vue')
  },
  {
    // Bankshot! (Game Boy) leaderboard, next to the playtest build at /bankshot/play.
    // Keep /hof: it's the short URL printed on the game's You Win screen, and /hof/<code> is what the QR opens
    // (a longer URL wouldn't fit the game's 25x25 QR).
    path: '/bankshot/hof/:code?',
    alias: ['/hof/:code?', '/bankshot-hall-of-fame/:code?'],
    name: 'BankshotHallOfFame',
    component: () => import('@/views/HallOfFameView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Always scroll to top when navigating
    return { top: 0 }
  }
})

export default router